import { render, staticRenderFns } from "./historyDetails.vue?vue&type=template&id=1b4e205d"
import script from "./historyDetails.vue?vue&type=script&lang=js"
export * from "./historyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports